















































import { Type, ManyType, NullType, Expression, Exprs } from 'expangine-runtime';
import { getConfirmation } from '@/app/Confirm';
import { getBuildType } from '@/app/BuildType';
import { Preferences, PreferenceCategory } from '@/app/Preference';
import { TypeUpdateEvent } from '../TypeVisuals';
import { ManySubs, ManyOptions } from './ManyTypes';
import TypeEditorBase from '../TypeEditorBase';


const PREF_MANY_REMOVE = Preferences.define({
  key: 'many_remove',
  label: 'Remove type from Many without confirmation',
  category: [PreferenceCategory.DESIGN, PreferenceCategory.CONFIRM],
  defaultValue: false,
});


export default TypeEditorBase<ManyType, ManyOptions, ManySubs>().extend({
  name: 'ManyEditor',
  methods: {
    requiredTypeFor(type: Type, index: number): Type | null {
      if (!(this.requiredType instanceof ManyType)) {
        return null;
      }

      const subs = this.requiredType.options;
      const valid = subs.find((sub) => this.isValidType(sub, type));

      return valid || NullType.baseType;
    },
    async removeType(index: number, innerType: Type) {
      if (!await getConfirmation({ pref: PREF_MANY_REMOVE })) {
        return;
      }

      const transform = this.type.getValueChangeExpression(Exprs.noop(), index, undefined);

      this.type.options.splice(index, 1);
      this.settings.sub.splice(index, 1);

      const { type, settings } = this;
      const simplify = this.type.options.length === 1;

      this.triggerChange({
        type: simplify ? type.options[0] : type,
        settings: simplify ? settings.sub[0] : settings,
        transform,
      });
    },
    async addType(index: number, afterType: Type) {
      const chosen = await getBuildType({
        input: {
          registry: this.registry,
        },
        title: 'Add Type',
        ok: 'Add',
      });

      if (!chosen) {
        return;
      }

      this.type.options.splice(index + 1, 0, chosen.type);
      this.settings.sub.splice(index + 1, 0, chosen.settings);

      this.update();
    },
    onChange(index: number, innerType: Type, event: TypeUpdateEvent) {
      this.$set(this.type.options, index, event.type);
      this.$set(this.settings.sub, index, event.settings);

      const transform = event.transform
        ? this.type.getValueChangeExpression(event.transform, index, index)
        : undefined;

      this.change({ transform });
    },
  },
});
